import React, { Fragment, useState, useEffect } from 'react'
import Dialog from '../../../Components/Dialog'
import Button from '../../../Components/Button'
import './index.scss'
import Check from '../../../Utils/Check'
import FollowTips from '../FollowTips'
import e from '../../../Utils/Event'
import {riskManagement, getIdentifyCodeWithCaptcha} from '../../../Utils/Utils'

const inputRef = React.createRef()
export default function BindTencentDialog(props) {
  let { visible, setVisible, result, subTitle, initPhone, toAppeal, saveForm } = props

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');

  //绑定确认前弹窗
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [userPic, setUserPic] = useState('')
  const [userName, setUserName] = useState('名字来的')
  const [userStatusStr, setUserStatusStr] = useState('审核中，但是还没到审核中的到')
  const [reqId, setReqId] = useState('')
  const [role, setRole] = useState(1)
  const [roleStr, setRoleStr] = useState('类型')

  //倒计时
  const [countNum, setCountNum] = useState(0)
  let timer = null;

  async function sendAuthCode() {
    if (countNum) return;
    if (!phone || !Check.phone(phone)) {
      return window.$Msg('请输入正确的手机号码')
    }
    try {
      const captchaParam = await getIdentifyCodeWithCaptcha();  // 发送验证码前调用这个方法
      console.log(captchaParam, 'captchaParam BindTencentDialog');
      countDown(60)
      window.$req('sendSmsCode', {
        type: 0, 
        phone: '+86*' + phone,
        platformAccountId: window.$userInfo.userid,
        platformIdType: 2,
        ticket: captchaParam.ticket,
        randstr: captchaParam.randstr
      }).then(res => {
        window.$Msg('发送成功')
      }).catch(rese => {
        console.log(rese, 'sendAuthCode BindTencentDialog catch');
        window.$Msg(rese && rese.message ? rese.message : '发送失败，请稍后刷新重试~');
      })
    } catch (error) {
      console.log(error, 'sendAuthCode BindTencentDialog error');
    }
  }

  function countDown(num) {
    setCountNum(num)
    if (!num) return;
    timer = setTimeout(() => {
      num--
      countDown(num)
    }, 1000)
  }

  function confirm() {
    if (!code) {
      return window.$Msg('请输入验证码')
    }
    let trimCode = code.trim()
    if (trimCode.length !== 6) {
      return window.$Msg('请输入6位验证码')
    }

    e.emit('loading', true)
    window.$req('bindPhoneBefore', {
      phone: '+86*' + phone,
      identifycode: code,
      platformAccountId: window.$userInfo.userid,
      platformIdType: 2
    }).then(res => {
      e.emit('loading', false)
      e.emit('bottomBind', false)
      if (res.code == 0) {
        let data = res.data
        if ( data.status === -1 || data.status === 51 ) {//已注销账号直接到结果页
          e.emit('loading', false)
          setConfirmVisible(false)
          result(data.status, data)
          return;
        }
        setReqId(data.reqId)
        setUserPic(data.pic)
        setUserName(data.userName)
        setUserStatusStr( data.status === 50 ? '当前还未实名认证，请补充资料' : data.statusStr )
        setRole(data.role)
        setRoleStr(data.roleStr)
        setVisible(false)
        setConfirmVisible(true)
      }
    }).catch(rese=> {
      e.emit('loading', false)
      if((rese.errcode === 20028 || rese.errcode === 20029) && window.rejectRes) {//触发风控
        riskManagement(window.rejectRes);
        return;
      }
      let codeMap = [100004, 1000030, 1000031, 1000032]
      if (rese.code) {
        if (~codeMap.indexOf(Number(rese.code))) {
          //返回对应用户状态
          result(rese.code, { message: rese.message })
        } else {
          window.$Msg(rese.message)
        }
      } else {
        window.$Msg('服务异常，请稍后重试')
      }
    })


    //旧的直接绑定接口不用了
    // window.$req('phoneBindMusician', {
    //   phone: '+86*' + phone,
    //   identifycode: code,
    //   platformAccountId: window.$userInfo.userid,
    //   platformIdType: 2
    // }).then(res => {
    //   e.emit('bottomBind', false)
    //   //返回用户状态
    //   //这里后端改过接口，慎重处理，不改原组件处理逻辑，将内置status抽出来
    //   let data = res.data || {}
    //   let users = Array.isArray(data.users) ? data.users : []
    //   let findItem = users.find(ele => ele.role === 1)
    //   data.accountStatus = data.status
    //   //外置对应音乐人的状态
    //   let gotStatus = findItem ? findItem.status : 0
    //   data.status = gotStatus

    //   // 黑名单和已注销直接覆盖
    //   if (data.delete) {
    //     data.status = 900
    //   } else if (data.black) {
    //     data.status = 901
    //   }
    //   window.$userStatus = data
    //   result(data.status, findItem || {})
    // }).catch(e => {
    //   let codeMap = [100004, 1000030, 1000031, 1000032]
    //   if (e.code) {
    //     if (~codeMap.indexOf(Number(e.code))) {
    //       //返回对应用户状态
    //       result(e.code, { message: e.message })
    //     } else {
    //       window.$Msg(e.message)
    //     }
    //   } else {
    //     window.$Msg('服务异常，请稍后重试')
    //   }
    // })

  }

  useEffect(() => {
    setPhone(initPhone || '')
    setCode('')
    return () => {
      clearTimeout(timer)
    }
  }, [timer, visible])

  useEffect(() => {
    if(visible){
      inputRef && inputRef.current && inputRef.current.focus()
    }
  }, [visible])

  return (<Fragment>
    <Dialog visible={visible} setVisible={setVisible} title="绑定腾讯音乐人" titleStyle={{ marginBottom: '0' }}>
      <div className="BindTencentDialog">
        <header>{subTitle || '请输入您入驻腾讯音乐人时填写的手机号'}</header>

        {(!subTitle || !!~subTitle.indexOf('直接验证绑定即可')) && <Fragment>
          <section className="line">
            <input ref={inputRef} type="text" placeholder="请输入手机号" value={phone} onChange={e => setPhone(e.target.value)}></input>

          </section>
          <section className="line">
            <input type="text" placeholder="填入验证码" value={code} onChange={e => setCode(e.target.value)}></input>
            <div className={"send" + (countNum ? ' wait' : '')} onClick={sendAuthCode}>{countNum ? (countNum + 's') : '发送验证码'}</div>
            {/* <div className="send" onClick={sendAuthCode}>发送验证码</div> */}
          </section>

          <div className="confirm">
            <Button text="确认绑定" fn={confirm} />
          </div>

        </Fragment>}

        {subTitle && !initPhone && <div className="toJudge" onClick={toAppeal}>
          不是本人入驻，<span>去申诉></span>
        </div>}

        <div className="follow">
          <FollowTips />
        </div>

      </div>
    </Dialog>


    <Dialog title={`类型：${roleStr}`} titleStyle={{ color: '#0090ff', marginBottom: '0.44rem', marginTop: '0.3rem', paddingLeft:'0.3rem', textAlign: 'left'}} visible={confirmVisible} setVisible={setConfirmVisible}>
      <div className="beforeBind">
        <section className="portrait">
          < img src={userPic || 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png'} alt="" onError={e => {
            let target = e.target
            target.onerror = null;
            {/* target.src = 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png' */}
          }} />
        </section>
        <section className="name">{userName}</section>
        <section className="desc">{userStatusStr}</section>

        <section className="btnGroup">
          <div className="left" onClick={e => {
            setConfirmVisible(false)
          }}>取消</div>
          <div className="right" onClick={oe => {
            e.emit('loading', true)
            window.$req('bindPhoneConfirm', {
              reqId,
              platformAccountId: window.$userInfo.userid,
              platformIdType: 2
            }).then(res => {
              e.emit('loading', false)
              if (res.code == 0) {
                window.$getUserStatus(({ status }, findItem) => {
                  e.emit('loading', false)
                  setConfirmVisible(false)
                  if(status === 70){
                    saveForm()
                  }
                  result(status, Object.assign({}, findItem || {}, { role }))
                }, true)
              }
            }).catch(rese=> {
              e.emit('loading', false)
              setConfirmVisible(false)
              if((rese.errcode === 20028 || rese.errcode === 20029) && window.rejectRes) {//触发风控
                riskManagement(window.rejectRes);
                return;
              }
              window.$Msg(rese.msg || rese.message||'服务异常，请稍后重试')
            })
          }}>确定绑定</div>
        </section>
      </div>

    </Dialog>

  </Fragment>)
}